<div class="container">
  <gc-custom-tab-body
    *ngFor="let tab of tabs; let i = index"
    [class.active]="_selectedIndex === i"
    class="tab-body"
    [position]="tab.position"
    [origin]="tab.origin"
    [content]="tab.content"
  ></gc-custom-tab-body>
</div>
